import { supabase } from '@/core/database/supabase';
import type { UserProfile, UserFilters, UserStats } from '../types/userList.types';

export const UserListService = {
 async getUsers(companyId: string, filters: UserFilters = {}) {
 let query = supabase
 .from('user_profiles')
 .select('*', { count: 'exact' })
 .eq('company_id', companyId);

 if (filters.search) {
 query = query.or(`full_name.ilike.%${filters.search}%,user_code.ilike.%${filters.search}%,email.ilike.%${filters.search}%`);
 }
  if (filters.status && filters.status !== 'all') {
    query = query.eq('is_active', filters.status === 'active');
  }
  if (filters.role_code && filters.role_code !== 'all') {
    query = query.eq('role_code', filters.role_code);
  }
  if (filters.skill && filters.skill !== 'all') {
    query = query.contains('skills', [filters.skill]);
  }

 const { data, error, count } = await query.order('full_name', { ascending: true });

 if (error) throw error;
 return { data: data as UserProfile[], total: count || 0 };
 },

 async getUserStats(companyId: string): Promise<UserStats> {
 const { data, error } = await supabase
 .from('user_profiles')
 .select('is_active')
 .eq('company_id', companyId);

 if (error) throw error;

 const stats: UserStats = {
 total: data.length,
 active: data.filter(u => u.is_active).length,
 on_leave: 0,
 suspended: 0,
 resigned: data.filter(u => !u.is_active).length,
 };

 return stats;
 },

 async getUserDetail(id: string): Promise<UserProfile> {
 const { data, error } = await supabase
 .from('user_profiles')
 .select('*')
 .eq('id', id)
 .single();

 if (error) throw error;
 return data as UserProfile;
 }
};
